// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"baa-z","subtitle":"caa-z","wrapper":"daa-z","leftArrow":"eaa-z","rightArrow":"faa-z"};